module.exports = __webpack_public_path__ + "img/iPad-Mini.7feece07.png";